import { FunctionComponent } from 'react';
import RulerRegularIcon from '../../Icons/RulerRegularIcon';
import styles from '../styles.module.scss';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export const LevelHighlight: FunctionComponent<{ course: PublicCourse }> = ({ course }) => {
    if (!course.level) {
        return null;
    }

    const levelText = course.level === 'All' ? 'All levels' : `${course.level} level`;

    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <RulerRegularIcon />
            </span>
            <p>{levelText}</p>
        </li>
    );
};
